module.exports = __webpack_public_path__ + "static/media/feature.9175c0bc.jpg";